import i18n from 'i18next';
// import languageDetector from 'i18next-browser-languagedetector';  //for auto detecting user's language uncomment this line
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

i18n
  .use(Backend)
  // .use(languageDetector) //for auto detecting user's language uncomment this line
  .use(initReactI18next)
  .init({
    fallbackLng: 'pt-BR',
    ns: [
      'translation',
      'navbar',
      'sidebar',
      'login',
      'authorization',
      'common',
      'periodDetails',
      'dashboard',
      'provider',
      'periods',
      'projects',
      'equipment',
      'construction',
      'humanResource',
      'books',
      'consumable',
      'travel',
      'training',
      'relatedService',
      'generateReport',
      'roles',
      'costTracking',
    ],
    debug: false,
    lng: 'pt-br', // for auto detecting user's language uncomment this

    // have a common namespace used around the full app
    defaultNS: 'translation',

    interpolation: {
      escapeValue: true,
    },
  });

export default i18n;
